import type { JSX } from 'react';

import type { ErrorHandlerProps } from 'src/app/pages/decisionMakerProfile/pageContext';

export function DecisionMakerProfileErrorHandler({ context: { error } }: ErrorHandlerProps): JSX.Element {
	throw new Error(`Failed to retrieve data for DecisionMakerProfile page (error: ${error})`);
}
